"use strict";
// db/supabaseTables.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.TABLES = void 0;
exports.TABLES = {
    projects: "projects",
    userProjectRoles: "userProjectRoles",
    products: "products",
    suppliers: "suppliers",
    categories: "categories",
    currencies: "currencies",
    offices: "offices",
    units: "units",
    users: "users",
    donors: "donors",
    supplierRatings: "supplierRatings",
    usersTokens: "usersTokens",
    budgetLines: "budgetLines",
    budgetLineItems: "budgetLineItems",
    budgetSections: "budgetSections",
    budgetTemplates: "budgetTemplates",
    procurementPlans: "procurementPlans",
    orders: "orders",
    approvals: "approvals",
    CBAs: "CBAs",
    IRs: "IRs",
    IRItems: "IRItems",
    DNs: "DNs",
    POs: "POs",
    POItems: "POItems",
    PRs: "PRs",
    PRItems: "PRItems",
    RFQs: "RFQs",
    rfqItems: "RFQItems",
    cbaItems: "CBAItems",
    cbaRFQItems: "CBARFQItems",
    SCNs: "SCNs",
    scnItems: "SCNItems",
    SCs: "SCs",
    serviceContractItems: "SCItems",
    warehouses: "warehouses",
    warehouseItems: "warehouseItems",
    warehouseImportOperations: "warehouseImportOperations",
    warehouseCorrectionOperation: "warehouseCorrectionOperation",
    warehouseTransferOperations: "warehouseTransferOperations",
    warehouseTransferToAnotherProjectOperations: "warehouseTransferToAnotherProjectOperations",
    warehouseDisposeOperations: "warehouseDisposeOperations",
    warehouseConsumeOperations: "warehouseConsumeOperations",
    warehouseSendDonationOperations: "warehouseSendDonationOperations",
    warehouseReceiveDonationOperations: "warehouseReceiveDonationOperations",
    warehousePrescriptionConsumptionOperations: "warehousePrescriptionConsumptionOperations",
    warehousePrescriptionConsumptionOperationItems: "warehousePrescriptionConsumptionOperationItems",
    warehouseMedicationsPrescriptionConsumptionOperations: "warehouseMedicationsPrescriptionConsumptionOperations",
    warehouseMedicationsPrescriptionConsumptionOperationItems: "warehouseMedicationsPrescriptionConsumptionOperationItems",
    warehouseMaintenanceItems: "warehouseMaintenanceItems",
    warehouseAssignedAssets: "warehouseAssignedAsstes",
    gio: "GIOs",
    gioItems: "GIOItems",
    sr: "SRs",
    srItems: "SRItems",
    userTokens: "userTokens",
    discussions: "discussions",
    notifications: "notifications",
    warehouseOperationsNotifications: "warehouseOperationsNotifications",
    roles: "roles",
    warehouseRoles: "warehouseRoles",
    // HIMS data (separate schema or DB)
    himsSessions: "sessions",
    himsPatients: "patients",
    himsAdmissions: "admissions",
    himsMedications: "medications",
    himsMedicationItems: "medicationsItems",
    himsPrescriptions: "prescriptions",
};
